import { render, staticRenderFns } from "./WvcPagination.vue?vue&type=template&id=78479c60&scoped=true&"
import script from "./WvcPagination.vue?vue&type=script&lang=js&"
export * from "./WvcPagination.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./WvcPagination.vue?vue&type=style&index=0&id=78479c60&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "78479c60",
  null
  ,true
)

export default component.exports